import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { initializePropertyDefaults } from 'sh-www/utils/initialize-state-properties';

export default Service.extend({
  /**
   * Register Services
   */
  session: service(),
  store: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * @type {Boolean}      True if we are editing the memo
     */
    isEditingMemo: false,

    /**
     * True if we are loading the invoice state.
     *
     * @type {Boolean}
     */
    isLoadingInvoice: false,

    /**
     * @type {Boolean}      True if we are saving the memo to the db
     */
    isSavingMemo: false,

    /** @type {Boolean} */
    isApproving: false,

    /**
     * @type {Boolean}      True when sending the invoice request to the API.
     */
    isSendingInvoice: false,

    /**
     * @type {Boolean}      True when batch request is going to the API.
     */
    isUnBatchSending: false,

    /**
     * @type {ShInvoice}
     */
    shInvoice: null,

    /**
     * @type {String}       The updated memo text as input by the user
     */
    updatedMemoText: '',
  },

  /**
   * This will return an array of tuples of the costCode bucket name and the shInvoices array of invoices associated
   * with the particular cost code for all of the child invoices off this invoice.
   *
   * @type {Ember.A<{
   *   costCode: <String>,
   *   shInvoices: Ember.A<ShInvoice>
   * }>}
   */
  childInvoicesBucketedByCostCode: computed('shInvoice.childShInvoices.[]', function() {
    if (!this.shInvoice.childShInvoices) {
      return [];
    }

    const buckets = this.shInvoice.childShInvoices.reduce((accum, shInvoice) => {
      const costCode = shInvoice.application.costCode?.body ?? 'NONE';
      accum[costCode] ??= [];
      accum[costCode].push(shInvoice);
      return accum;
    }, { });

    const bucketizedChildShInvoices = Object.entries(buckets).map(([costCode, shInvoices]) => ({
      costCode,
      shInvoices,
    }));

    return bucketizedChildShInvoices;
  }),

  /**
   * @inheritDoc
   */
  init() {
    this._super(...arguments);
    initializePropertyDefaults(this);
  },
});
